/*eslint id-length: 0 */
import _ from '../i18n.jsx';
const countriesList = [
    { name: _('Afghanistan'), code: '', value: 143 },
    { name: _('Albania'), code: '', value: 72 },
    { name: _('Algeria'), code: '', value: 1 },
    { name: _('American Samoa'), code: '', value: 144 },
    { name: _('Andorra'), code: '', value: 73 },
    { name: _('Angola'), code: '', value: 2 },
    { name: _('Anguilla'), code: '', value: 145 },
    { name: _('Antarctica'), code: '', value: 146 },
    { name: _('Antigua and Barbuda'), code: '', value: 74 },
    { name: _('Argentina'), code: '', value: 3 },
    { name: _('Armenia'), code: '', value: 147 },
    { name: _('Aruba'), code: '', value: 75 },
    { name: _('Australia'), code: '', value: 4 },
    { name: _('Austria'), code: '', value: 148 },
    { name: _('Azerbaijan'), code: '', value: 76 },
    { name: _('Bahamas'), code: '', value: 5 },
    { name: _('Bahrain'), code: '', value: 149 },
    { name: _('Bangladesh'), code: '', value: 150 },
    { name: _('Barbados'), code: '', value: 77 },
    { name: _('Belarus'), code: '', value: 6 },
    { name: _('Belgium'), code: '', value: 151 },
    { name: _('Belize'), code: '', value: 78 },
    { name: _('Benin'), code: '', value: 7 },
    { name: _('Bermuda'), code: '', value: 152 },
    { name: _('Bhutan'), code: '', value: 79 },
    { name: _('Bolivia'), code: '', value: 8 },
    { name: _('Bosnia and Herzegovina'), code: '', value: 153 },
    { name: _('Botswana'), code: '', value: 154 },
    { name: _('Brazil'), code: '', value: 80 },
    { name: _('Brunei Darussalam'), code: '', value: 9 },
    { name: _('Bulgaria'), code: '', value: 155 },
    { name: _('Burkina Faso'), code: '', value: 81 },
    { name: _('Burundi'), code: '', value: 10 },
    { name: _('Cambodia'), code: '', value: 156 },
    { name: _('Cameroon'), code: '', value: 82 },
    { name: _('Canada'), code: '', value: 11 },
    { name: _('Cape Verde'), code: '', value: 157 },
    { name: _('Cayman Islands'), code: '', value: 158 },
    { name: _('Central African Republic'), code: '', value: 83 },
    { name: _('Chad'), code: '', value: 12 },
    { name: _('Chile'), code: '', value: 159 },
    { name: _('China'), code: '', value: 84 },
    { name: _('Christmas Island'), code: '', value: 13 },
    { name: _('Cocos (Keeling) Islands'), code: '', value: 160 },
    { name: _('Colombia'), code: '', value: 85 },
    { name: _('Comoros'), code: '', value: 14 },
    { name: _('Congo, Republic of (Brazzaville)'), code: '', value: 162 },
    { name: _('Cook Islands'), code: '', value: 86 },
    { name: _('Costa Rica'), code: '', value: 15 },
    { name: _('Croatia'), code: '', value: 87 },
    { name: _('Cuba'), code: '', value: 16 },
    { name: _('Cyprus'), code: '', value: 164 },
    { name: _('Czech Republic'), code: '', value: 88 },
    { name: _('Democratic Republic of the Congo (Kinshasa)'), code: '', value: 161 },
    { name: _('Denmark'), code: '', value: 17 },
    { name: _('Djibouti'), code: '', value: 165 },
    { name: _('Dominica'), code: '', value: 166 },
    { name: _('Dominican Republic'), code: '', value: 89 },
    { name: _('East Timor (Timor-Leste)'), code: '', value: 18 },
    { name: _('Ecuador'), code: '', value: 167 },
    { name: _('Egypt'), code: '', value: 90 },
    { name: _('El Salvador'), code: '', value: 19 },
    { name: _('Equatorial Guinea'), code: '', value: 168 },
    { name: _('Eritrea'), code: '', value: 91 },
    { name: _('Estonia'), code: '', value: 20 },
    { name: _('Ethiopia'), code: '', value: 169 },
    { name: _('Falkland Islands'), code: '', value: 170 },
    { name: _('Faroe Islands'), code: '', value: 92 },
    { name: _('Fiji'), code: '', value: 21 },
    { name: _('Finland'), code: '', value: 171 },
    { name: _('France'), code: '', value: 93 },
    { name: _('French Guiana'), code: '', value: 22 },
    { name: _('French Polynesia'), code: '', value: 172 },
    { name: _('French Southern Territories'), code: '', value: 94 },
    { name: _('Gabon'), code: '', value: 23 },
    { name: _('Gambia'), code: '', value: 173 },
    { name: _('Georgia'), code: '', value: 174 },
    { name: _('Germany'), code: '', value: 95 },
    { name: _('Ghana'), code: '', value: 24 },
    { name: _('Gibraltar'), code: '', value: 175 },
    { name: _('Great Britain'), code: '', value: 96 },
    { name: _('Greece'), code: '', value: 25 },
    { name: _('Greenland'), code: '', value: 176 },
    { name: _('Grenada'), code: '', value: 97 },
    { name: _('Guadeloupe'), code: '', value: 26 },
    { name: _('Guam'), code: '', value: 177 },
    { name: _('Guatemala'), code: '', value: 178 },
    { name: _('Guinea'), code: '', value: 98 },
    { name: _('Guinea-Bissau'), code: '', value: 27 },
    { name: _('Guyana'), code: '', value: 179 },
    { name: _('Haiti'), code: '', value: 99 },
    { name: _('Holy See'), code: '', value: 28 },
    { name: _('Honduras'), code: '', value: 180 },
    { name: _('Hong Kong'), code: '', value: 100 },
    { name: _('Hungary'), code: '', value: 29 },
    { name: _('Iceland'), code: '', value: 181 },
    { name: _('India'), code: '', value: 182 },
    { name: _('Indonesia'), code: '', value: 101 },
    { name: _('Iran (Islamic Republic of)'), code: '', value: 30 },
    { name: _('Iraq'), code: '', value: 183 },
    { name: _('Ireland'), code: '', value: 102 },
    { name: _('Israel'), code: '', value: 31 },
    { name: _('Italy'), code: '', value: 184 },
    { name: _('Ivory Coast'), code: '', value: 163 },
    { name: _('Jamaica'), code: '', value: 103 },
    { name: _('Japan'), code: '', value: 32 },
    { name: _('Jordan'), code: '', value: 185 },
    { name: _('Kazakhstan'), code: '', value: 186 },
    { name: _('Kenya'), code: '', value: 104 },
    { name: _('Kiribati'), code: '', value: 33 },
    { name: _(`Korea, Democratic People's Rep. (North Korea)`), code: '', value: 187 },
    { name: _('Korea, Republic of (South Korea)'), code: '', value: 105 },
    { name: _('Kosovo'), code: '', value: 34 },
    { name: _('Kuwait'), code: '', value: 188 },
    { name: _('Kyrgyzstan'), code: '', value: 106 },
    { name: _(`Lao, People's Democratic Republic`), code: '', value: 35 },
    { name: _('Latvia'), code: '', value: 189 },
    { name: _('Lebanon'), code: '', value: 190 },
    { name: _('Lesotho'), code: '', value: 107 },
    { name: _('Liberia'), code: '', value: 36 },
    { name: _('Libya'), code: '', value: 191 },
    { name: _('Liechtenstein'), code: '', value: 108 },
    { name: _('Lithuania'), code: '', value: 37 },
    { name: _('Luxembourg'), code: '', value: 192 },
    { name: _('Macau'), code: '', value: 109 },
    { name: _('Macedonia, Rep. of'), code: '', value: 38 },
    { name: _('Madagascar'), code: '', value: 193 },
    { name: _('Malawi'), code: '', value: 194 },
    { name: _('Malaysia'), code: '', value: 110 },
    { name: _('Maldives'), code: '', value: 39 },
    { name: _('Mali'), code: '', value: 195 },
    { name: _('Malta'), code: '', value: 111 },
    { name: _('Marshall Islands'), code: '', value: 40 },
    { name: _('Martinique'), code: '', value: 196 },
    { name: _('Mauritania'), code: '', value: 112 },
    { name: _('Mauritius'), code: '', value: 41 },
    { name: _('Mayotte'), code: '', value: 197 },
    { name: _('Mexico'), code: '', value: 198 },
    { name: _('Micronesia, Federal States of'), code: '', value: 113 },
    { name: _('Moldova, Republic of'), code: '', value: 42 },
    { name: _('Monaco'), code: '', value: 199 },
    { name: _('Mongolia'), code: '', value: 114 },
    { name: _('Montenegro'), code: '', value: 43 },
    { name: _('Montserrat'), code: '', value: 200 },
    { name: _('Morocco'), code: '', value: 115 },
    { name: _('Mozambique'), code: '', value: 44 },
    { name: _('Myanmar, Burma'), code: '', value: 201 },
    { name: _('Namibia'), code: '', value: 202 },
    { name: _('Nauru'), code: '', value: 116 },
    { name: _('Nepal'), code: '', value: 45 },
    { name: _('Netherlands'), code: '', value: 203 },
    { name: _('Netherlands Antilles'), code: '', value: 117 },
    { name: _('New Caledonia'), code: '', value: 46 },
    { name: _('New Zealand'), code: '', value: 204 },
    { name: _('Nicaragua'), code: '', value: 118 },
    { name: _('Niger'), code: '', value: 47 },
    { name: _('Nigeria'), code: '', value: 205 },
    { name: _('Niue'), code: '', value: 206 },
    { name: _('Northern Mariana Islands'), code: '', value: 119 },
    { name: _('Norway'), code: '', value: 48 },
    { name: _('Oman'), code: '', value: 207 },
    { name: _('Pakistan'), code: '', value: 120 },
    { name: _('Palau'), code: '', value: 49 },
    { name: _('Palestinian territories'), code: '', value: 208 },
    { name: _('Panama'), code: '', value: 121 },
    { name: _('Papua New Guinea'), code: '', value: 50 },
    { name: _('Paraguay'), code: '', value: 209 },
    { name: _('Peru'), code: '', value: 210 },
    { name: _('Philippines'), code: '', value: 122 },
    { name: _('Pitcairn Island'), code: '', value: 51 },
    { name: _('Poland'), code: '', value: 211 },
    { name: _('Portugal'), code: '', value: 123 },
    { name: _('Puerto Rico'), code: '', value: 52 },
    { name: _('Qatar'), code: '', value: 212 },
    { name: _('Reunion Island'), code: '', value: 124 },
    { name: _('Romania'), code: '', value: 53 },
    { name: _('Russian Federation'), code: '', value: 213 },
    { name: _('Rwanda'), code: '', value: 214 },
    { name: _('Saint Kitts and Nevis'), code: '', value: 125 },
    { name: _('Saint Lucia'), code: '', value: 54 },
    { name: _('Saint Vincent and the Grenadines'), code: '', value: 215 },
    { name: _('Samoa'), code: '', value: 126 },
    { name: _('San Marino'), code: '', value: 55 },
    { name: _('Sao Tome and Principe'), code: '', value: 216 },
    { name: _('Saudi Arabia'), code: '', value: 127 },
    { name: _('Senegal'), code: '', value: 56 },
    { name: _('Serbia'), code: '', value: 217 },
    { name: _('Seychelles'), code: '', value: 218 },
    { name: _('Sierra Leone'), code: '', value: 128 },
    { name: _('Singapore'), code: '', value: 57 },
    { name: _('Slovakia (Slovak Republic)'), code: '', value: 219 },
    { name: _('Slovenia'), code: '', value: 129 },
    { name: _('Solomon Islands'), code: '', value: 58 },
    { name: _('Somalia'), code: '', value: 220 },
    { name: _('South Africa'), code: '', value: 130 },
    { name: _('South Sudan'), code: '', value: 59 },
    { name: _('Spain'), code: '', value: 221 },
    { name: _('Sri Lanka'), code: '', value: 222 },
    { name: _('Sudan'), code: '', value: 131 },
    { name: _('Suriname'), code: '', value: 60 },
    { name: _('Swaziland'), code: '', value: 223 },
    { name: _('Sweden'), code: '', value: 132 },
    { name: _('Switzerland'), code: '', value: 61 },
    { name: _('Syria, Syrian Arab Republic'), code: '', value: 224 },
    { name: _('Taiwan (Republic of China)'), code: '', value: 133 },
    { name: _('Tajikistan'), code: '', value: 62 },
    { name: _('Tanzania; officially the United Republic of Tanzania'), code: '', value: 225 },
    { name: _('Thailand'), code: '', value: 226 },
    { name: _('Tibet'), code: '', value: 134 },
    { name: _('Timor-Leste (East Timor)'), code: '', value: 63 },
    { name: _('Togo'), code: '', value: 227 },
    { name: _('Tokelau'), code: '', value: 135 },
    { name: _('Tonga'), code: '', value: 64 },
    { name: _('Trinidad and Tobago'), code: '', value: 228 },
    { name: _('Tunisia'), code: '', value: 136 },
    { name: _('Turkey'), code: '', value: 65 },
    { name: _('Turkmenistan'), code: '', value: 229 },
    { name: _('Turks and Caicos Islands'), code: '', value: 230 },
    { name: _('Tuvalu'), code: '', value: 137 },
    { name: _('Uganda'), code: '', value: 66 },
    { name: _('Ukraine'), code: '', value: 231 },
    { name: _('United Arab Emirates'), code: '', value: 138 },
    { name: _('United Kingdom'), code: '', value: 67 },
    { name: _('United States'), code: '', value: 232 },
    { name: _('Uruguay'), code: '', value: 139 },
    { name: _('Uzbekistan'), code: '', value: 68 },
    { name: _('Vanuatu'), code: '', value: 233 },
    { name: _('Vatican City State (Holy See)'), code: '', value: 234 },
    { name: _('Venezuela'), code: '', value: 140 },
    { name: _('Vietnam'), code: '', value: 69 },
    { name: _('Virgin Islands (British)'), code: '', value: 235 },
    { name: _('Virgin Islands (U.S.)'), code: '', value: 141 },
    { name: _('Wallis and Futuna Islands'), code: '', value: 70 },
    { name: _('Western Sahara'), code: '', value: 236 },
    { name: _('Yemen'), code: '', value: 142 },
    { name: _('Zambia'), code: '', value: 71 },
    { name: _('Zimbabwe'), code: '', value: 237 }
];
export default countriesList;
